/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Label_RejecterInputs */

const vi_sl_detail_label_rejecter = /** @type {(inputs: Sl_Detail_Label_RejecterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người từ chối`)
};

/**

* @param {Sl_Detail_Label_RejecterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_label_rejecter = /** @type {((inputs?: Sl_Detail_Label_RejecterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Label_RejecterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_label_rejecter(inputs)
});